import "./src/styles/fonts.css"

import configureAmplify from "./src/configureAmplify"
import wrapPageElement from "./src/wrapPageElement"
import wrapRootElement from "./src/wrapRootElement"

configureAmplify()

export { wrapPageElement, wrapRootElement }
